import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useParams } from "react-router-dom";

import MediaAPI from "@/src/api/MediaAPI";

import type { Moment } from "moment";

/**
 * Resolves the current media's creation date (`inserted_at`) as a Moment, or
 * `null` while the media is loading. Backed by React Query, so every consumer
 * shares a single deduped `getMedia` fetch.
 */
function useMediaCreationDate(): Moment | null {
  const { id } = useParams<{ id: string }>();

  const getMediaQuery = MediaAPI.generateQuery({
    fn: MediaAPI.getMedia,
    params: [id],
  });
  const { data: media } = useQuery({
    ...getMediaQuery,
    enabled: !!id,
  });

  return media?.inserted_at ? moment(media.inserted_at) : null;
}

export default useMediaCreationDate;
